module.exports = __webpack_public_path__ + "static/media/home-toplu-mms.6bb64a7c.png";